import { showCustomDialog } from "../components/open-custom-dialog";

export const navigateTo = ({
    route,
    newTab,
    title = "",
    message = "",
}: {
    route: string;
    newTab: boolean;
    title?: string;
    message?: string;
}) => {
    if (newTab && window) {
        const createdWindow = window.open(route, "_blank");

        if (!createdWindow) {
            showCustomDialog({ route, title, message });
        }
    }
};

export const buildQueryAndExcludeRedirect = (params) => {
    let query = "";

    Object.keys(params).forEach((key) => {
        if (key !== "redirect") {
            query += `&${key}=${params[key]}`;
        }
    });

    return query;
};
